import { render } from "./DocumentReportOrigin.vue?vue&type=template&id=2112bc4e&scoped=true&ts=true"
import script from "./DocumentReportOrigin.vue?vue&type=script&lang=ts"
export * from "./DocumentReportOrigin.vue?vue&type=script&lang=ts"

import "./DocumentReportOrigin.vue?vue&type=style&index=0&id=2112bc4e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2112bc4e"]])

export default __exports__